import * as React from "react";
import { Button, Caption1, makeStyles, tokens } from "@fluentui/react-components";

import type { Session } from "../lib/session";

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    paddingBottom: "8px",
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  who: { color: tokens.colorNeutralForeground3, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
});

export interface AccountBarProps {
  session: Session;
  onSignOut: () => void;
}

/**
 * "Connected as…" plus sign out. Marketplace expects both sign in and sign out
 * to be visible in the UI, not buried.
 */
export const AccountBar: React.FC<AccountBarProps> = ({ session, onSignOut }) => {
  const styles = useStyles();

  // The profile lookup is allowed to fail during sign-in without costing the
  // user a session, so displayName can legitimately be empty. The client ID is
  // always known, because the user just typed it.
  const who = session.user.displayName || session.user.email || session.clientId || "your Valoon account";

  return (
    <div className={styles.root}>
      <Caption1 className={styles.who} title={who}>
        Connected as {who}
      </Caption1>
      <Button appearance="subtle" size="small" onClick={onSignOut}>
        Sign out
      </Button>
    </div>
  );
};
